import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { FormattedMessage } from 'translations';
import { connectSubpages } from 'app/hocs/subpageManagable';
import { Layout, Flex } from 'app/components/base/Layout';
import { DEPARTING_CRUISE_FIELD_NAME, AUTOCOMPLETE_TYPES } from 'app/constants';

import style from './style.css';

const messages = {
  fromLabel: { id: 'TRIP_DETAILS.FROM' },
  toLabel: { id: 'TRIP_DETAILS.TO' },
  forYourCruise: { id: 'TRIP_DETAILS.FOR_YOUR_CRUISE' },
  departing: { id: 'TRIP_DETAILS.DEPARTING' },
  arriving: { id: 'TRIP_DETAILS.ARRIVING' },
  returning: { id: 'TRIP_DETAILS.RETURNING' },
  cruisePlaceholder: { id: 'BOOK_TRIP.CRUISE.PLACEHOLDER' },
};

/**
 * Builder to show "Cruise selector" label of the field and Port name (to/from)
 * @param  {Component} ComposedComponent
 * @return {Component}
 */
export const builder = (ComposedComponent) => {
  const WrapperComponent = ({ direction, portName, className, ...props }) => {
    const modifiers = {
      [style['block--departing']]: props.name === DEPARTING_CRUISE_FIELD_NAME,
    };

    const isTypeDeparting = props.name === DEPARTING_CRUISE_FIELD_NAME;
    const isDirectionToPort = direction === 'toPort';

    const isLabelDeparting = isDirectionToPort === isTypeDeparting;
    const directionMsg = isDirectionToPort
      ? messages.returning
      : messages.arriving;
    const tripTypeMsg = isLabelDeparting ? messages.departing : directionMsg;
    const conjunctionLabelMsg = isLabelDeparting
      ? messages.fromLabel
      : messages.toLabel;

    return (
      <Layout
        className={classnames(style.block, modifiers, className)}
        direction="column"
        nowrap
      >
        <Flex size="noshrink">
          <label className={style.label}>
            <FormattedMessage {...messages.forYourCruise} />
            &nbsp;
            <FormattedMessage {...tripTypeMsg} />
          </label>
          <label className={style.labelDirection}>
            <FormattedMessage {...conjunctionLabelMsg} />
          </label>
          <label className={style.labelAirport}>{portName}</label>
        </Flex>
        <Layout className={style.fields} size="noshrink" nowrap>
          <ComposedComponent
            className={style.autocompleteInput}
            fieldName={props.name}
            placeholder={<FormattedMessage {...messages.cruisePlaceholder} />}
            target={AUTOCOMPLETE_TYPES.CRUISE}
            rectangled
            {...props}
          />
        </Layout>
      </Layout>
    );
  };

  // TODO: move to Flow types
  // WrapperComponent.propTypes = {
  //   className: PropTypes.string,
  //   name: PropTypes.string,
  //   direction: PropTypes.oneOf(['departing', 'arriving']),
  //   portName: PropTypes.string.isRequired
  // };

  return compose(connectSubpages())(WrapperComponent);
};

export default builder;
